import { css } from 'emotion'
import { TEXT_COLOR_LIGHTER } from 'constants/styleConstants'

export const labelStyles = css`
  margin-bottom: 8px;
  color: ${TEXT_COLOR_LIGHTER};
  font-size: 0.75em;
  text-transform: capitalize;
`
